import { EFinancingCompany } from '@if/core/types'
import { Box, CircularProgress, Typography } from '@mui/material'
import Breadcrumb from '@src/components/Breadcrumb'
import { useMerchantById } from '@src/data/api/merchants-api/merchants-api'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import BannerTabsForm from './components/BannerTabsForm'

const EditBannerPage = () => {
  const { id } = useParams()
  const [banner, isLoading] = useMerchantById(id ?? '')

  const { t } = useTranslation()
  const navigate = useNavigate()

  const breadCrumbs = [
    { path: '/', label: t('breadcrumbs.home') },
    {
      path: `/banner/${banner?.id}/view`,
      label: t('breadcrumbs.banner').concat(` : ${banner?.name}`),
    },
    {
      path: `/banner/${banner?.id}/edit?financingCompanyId=${banner?.financingCompanyId}`,
      label: t('breadcrumbs.edit'),
    },
  ]

  if (isLoading) {
    return (
      <Box>
        <Breadcrumb trees={breadCrumbs} />
        <CircularProgress />
      </Box>
    )
  }
  if (!banner) {
    return <div>merchant not found</div>
  }
  if (banner.financingCompanyId === EFinancingCompany.Iceberg) navigate(`/banner/${id}/view`, { replace: true })

  return (
    <Box>
      <Breadcrumb trees={breadCrumbs} />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" gutterBottom>
          {t('banner.edit')}
        </Typography>
        <Typography variant="body1" color="text.secondary" fontSize={'1.5rem'}>
          {banner.name}
        </Typography>
      </Box>
      <BannerTabsForm banner={banner} />
    </Box>
  )
}

export default EditBannerPage
